import React, { useState, useEffect } from 'react';
import Footer from './../component/layout/Footer';
import Header from '../component/layout/Header';
import Page from '../component/utility/Page';
import axios from 'axios';
import { mainurl } from '../Mainurl';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../style/color';

import { notification } from '../component/hocs/notification';


import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { GiFarmer, GiField, GiWheat, GiGoat, GiFruitBowl } from 'react-icons/gi';

import { MdTrendingUp } from "react-icons/md";
import { TbPlant2 } from "react-icons/tb";
import { TbPresentationAnalyticsFilled } from "react-icons/tb";
import { FaLeaf } from "react-icons/fa6";
import { LuSprout } from "react-icons/lu";

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Typography from '@mui/material/Typography';
// import KitchenGardenDashboard from '../component/utility/home/KitchenGardenDashboard';
// import HorticultureDashboard from '../component/utility/home/HorticultureDashboard';

// Enhanced TabPanel with animations
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        opacity: value === index ? 1 : 0,
        transform: value === index ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.3s ease-in-out'
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Enhanced Stat Card Component
const StatCard = ({ title, value, icon: Icon, color, trend, loading }) => (
  <Col lg={3} md={6} className="mb-4">
    <Card className="stat-card h-100 shadow-sm border-0">
      <CardBody className="p-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="flex-grow-1">
            <h6 className="stat-title text-muted mb-2 fw-medium">{title}</h6>
            <h3 className="stat-value mb-1 fw-bold" style={{ color }}>
              {loading ? (
                <div className="loading-skeleton" style={{ width: '80px', height: '32px' }} />
              ) : (
                value || '0'
              )}
            </h3>
            {trend && (
              <small className="text-success d-flex align-items-center">
                <MdTrendingUp size={14} className="me-1" />
                +{trend}% from last month
              </small>
            )}
          </div>
          <div className="stat-icon-wrapper">
            <div
              className="stat-icon d-flex align-items-center justify-content-center"
              style={{ backgroundColor: `${color}15`, color }}
            >
              <Icon size={28} />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
);

// Loading skeleton component
const LoadingSkeleton = () => (
  <div className="loading-skeleton-wrapper">
    {[1, 2, 3, 4].map((i) => (
      <Col lg={3} md={6} className="mb-4" key={i}>
        <Card className="h-100 shadow-sm border-0">
          <CardBody className="p-4">
            <div className="loading-skeleton mb-2" style={{ width: '60%', height: '16px' }} />
            <div className="loading-skeleton mb-1" style={{ width: '40%', height: '32px' }} />
            <div className="loading-skeleton" style={{ width: '80%', height: '14px' }} />
          </CardBody>
        </Card>
      </Col>
    ))}
  </div>
);

// Empty state component
const EmptyState = ({ title, description, icon: Icon }) => (
  <div className="empty-state text-center py-5">
    <div className="empty-state-icon mb-3">
      <Icon size={64} className="text-muted opacity-50" />
    </div>
    <h5 className="text-muted mb-2">{title}</h5>
    <p className="text-muted small">{description}</p>
  </div>
);

const Home = () => {
  const [value, setValue] = useState(0);
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const [meetingData, setMeetingData] = useState([]);
  const [trainingData, setTrainingData] = useState([]);
  const [distributionData, setDistributionData] = useState([]);
  const [cultivationData, setCultivationData] = useState([]);
  const [inputDemandData, setInputDemandData] = useState([]);
  const [cropPlanningData, setCropPlanningData] = useState([]);


  useEffect(() => {
    get_db_stats();
    get_meeting_list();
    get_training_list();
    get_distribution_list();
    get_cultivation_list();
    get_inputDemand_list();
    get_crop_planning_list();
  }, []);

  const get_db_stats = async () => {
    try {
      setLoading(true);
      const postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": "0" }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Master/user_db_m',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
      // Handle error appropriately
    } finally {
      setLoading(false);
    }
  };

  const get_meeting_list = async (e) => {
    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "type": "2",
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Activity/event_view',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          date: row.event_date.split(" ")[0].split('-').reverse().join('-'),
          location: row.event_loc,
          user: row.user_name,
          topic: row.topic_desc,
          farmer_count: row.attendance,
        };
      });

      setMeetingData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load meetings. Please try again.",
        type: 'error'
      });
      notify();
    }
  };

  const get_training_list = async (e) => {

    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "type": "1",
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Activity/event_view',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          date: row.event_date.split(" ")[0].split('-').reverse().join('-'),
          location: row.event_loc,
          user: row.user_name,
          topic: row.subject_desc,
          farmer_count: row.attendance,
        };
      });

      setTrainingData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load training sessions. Please try again.",
        type: 'error'
      });
      notify();
    }
  };

  const get_distribution_list = async (e) => {

    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Activity/input_distribution_view',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          location: row.wh_id,
          date: row.distribution_date.split(" ")[0].split('-').reverse().join('-'),
          product_name: row.prod_name,
          total_qty: row.distribution_qty,
          farmer_count: row.total_farmer,
        };
      });

      setDistributionData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load distribution records. Please try again.",
        type: 'error'
      });
      notify();
    } finally {
      setLoading(false);
    }
  };

  const get_cultivation_list = async (e) => {

    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Traceability/cultivation_details_web',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          crop_name: row.crop_name,
          area: row.area,
          block_name: row.block_name,
          village_name: row.village_name,
          farmers: row.farmers,
        };
      });

      setCultivationData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load Cultivation records. Please try again.",
        type: 'error'
      });
      notify();
    } finally {
      setLoading(false);
    }
  };

  const get_inputDemand_list = async (e) => {

    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Activity/db_product_planning',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          prod_name: row.prod_name,
          uom: row.uom,
          fy: row.fy,
          village_name: row.village_name,
          farmer_name: row.farmer_name,
        };
      });

      setInputDemandData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load Input Demand records. Please try again.",
        type: 'error'
      });
      notify();
    } finally {
      setLoading(false);
    }
  };

  const get_crop_planning_list = async (e) => {

    try {
      let postData = [{
        "org_id": sessionStorage.getItem('org_id'),
        "user_id": sessionStorage.getItem('user_id'),
        "lang_id": 1
      }];

      const response = await axios({
        method: 'post',
        url: mainurl + 'Activity/db_crop_planning',
        data: postData,
        headers: { 'Content-Type': 'application/JSON' }
      });

      let list = response.data.map((row, index) => {
        return {
          sl: index + 1,
          crop_name: row.crop_name,
          area: row.area,
          block_name: row.block_name,
          village_name: row.village_name,
          farmer_name: row.farmer_name,
          fy: row.fy,
        };
      });

      setCropPlanningData(list);
    } catch (error) {
      let notify = notification({
        message: "Failed to load Crop planning records. Please try again.",
        type: 'error'
      });
      notify();
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const statData = [
    {
      title: "Total Farmers",
      value: stats?.[0]?.key_value,
      icon: GiFarmer,
      color: "#076538",
      trend: 12
    },
    {
      title: "Cultivation Area",
      value: stats?.[1]?.key_value,
      icon: GiField,
      color: "#2E8B57",
      trend: 8
    },
    {
      title: "Animal Count",
      value: stats?.[2]?.key_value,
      icon: GiGoat,
      color: "#8B4513",
      trend: 5
    },
    {
      title: "Total Harvesting",
      value: stats?.[3]?.key_value,
      icon: GiWheat,
      color: "#DAA520",
      trend: 15
    }
  ];

  const tabsData = [
    { label: "Kitchen Garden", icon: LuSprout },
    { label: "Vegetables", icon: GiFruitBowl },
    { label: "Horticulture", icon: FaLeaf },
    { label: "Aromatic", icon: TbPlant2 }
  ];

  return (
    <>
      <Header />

      <div className="page-container">
        <Page title='' breadcrumbs=''>
          {/* Dashboard Header */}
          <div className="dashboard-header p-3 mb-3 mt-3">
            <Row className="align-items-center">
              <Col>
                <h4 className="mb-1 fw-bold">Welcome to Veg Box</h4>
                <p className="mb-0 opacity-90">Do your farming operations and track key metrics</p>
                {/* <p className="mb-0 opacity-90">Monitor your farming operations and track key metrics</p> */}
              </Col>
              <Col xs="auto">
                <TbPresentationAnalyticsFilled size={48} className="opacity-75" />
              </Col>
            </Row>
          </div>

          {/* Stats Cards */}
          <Row className="g-4 mb-2">
            {loading ? (
              <LoadingSkeleton />
            ) : (
              statData.map((stat, index) => (
                <StatCard
                  key={index}
                  title={stat.title}
                  value={stat.value}
                  icon={stat.icon}
                  color={stat.color}
                  trend={stat.trend}
                  loading={loading}
                />
              ))
            )}
          </Row>

          <Row className="mb-1">
            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>MEETING</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Meeting Date",
                          selector: row => row.date,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Conducted By",
                          selector: row => row.user,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Topic",
                          selector: row => row.topic,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={meetingData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>TRAINING</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Training Date",
                          selector: row => row.date,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Conducted By",
                          selector: row => row.user,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Topic",
                          selector: row => row.topic,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={trainingData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>DISTRIBUTION</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Distribution Date",
                          selector: row => row.date,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Product Name",
                          selector: row => row.product_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Qty",
                          selector: row => row.total_qty,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={distributionData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>CULTIVATION</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Crop Name",
                          selector: row => row.crop_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Area",
                          selector: row => row.area,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Block Name",
                          selector: row => row.block_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Village Name",
                          selector: row => row.village_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Farmers",
                          selector: row => row.farmers,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={cultivationData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>INPUT DEMAND</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Product Name",
                          selector: row => row.prod_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Qty",
                          selector: row => row.uom,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "year",
                          selector: row => row.fy,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Village Name",
                          selector: row => row.village_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Farmers",
                          selector: row => row.farmer_name,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={inputDemandData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm={4} className="mb-2">
              <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                <CardBody className="" style={{height: '300px', padding: '1rem 0.7rem'}}>
                  <div className='text-center mb-2 text-primary fw-bold'>CROP PLANNING</div>
                  <div>
                    <DataTable
                      title=""
                      customStyles={custTableStyles}
                      columns={[
                        {
                          name: '#',
                          selector: row => row.sl,
                          sortable: false,
                          width: '50px',
                        },
                        {
                          name: "Crop Name",
                          selector: row => row.crop_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Area",
                          selector: row => row.area,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Year",
                          selector: row => row.fy,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Block Name",
                          selector: row => row.block_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Village Name",
                          selector: row => row.village_name,
                          sortable: false,
                          wrap: true,
                        },
                        {
                          name: "Farmers",
                          selector: row => row.farmer_name,
                          sortable: false,
                          wrap: true,
                        },
                      ]}
                      data={cropPlanningData}
                      highlightOnHover
                      fixedHeader
                      fixedHeaderScrollHeight="calc(300px - 60px)"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>

          </Row>




          {/* <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
            <CardBody className="p-0">
              <Box sx={{ width: '100%' }} className="enhanced-tabs">
                <Box sx={{ borderBottom: 'none', p: 2 }}>
                  <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="dashboard tabs"
                    sx={{
                      '& .MuiTabs-indicator': {
                        display: 'none'
                      }
                    }}
                  >
                    {tabsData.map((tab, index) => (
                      <Tab 
                        key={index}
                        label={
                          <div className="d-flex align-items-center gap-2">
                            <tab.icon size={18} />
                            {tab.label}
                          </div>
                        } 
                        {...a11yProps(index)} 
                      />
                    ))}
                  </Tabs>
                </Box>
                
                <div style={{ minHeight: '400px' }}>
                  <TabPanel value={value} index={0}>
                    <KitchenGardenDashboard />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <EmptyState 
                      title="Vegetables Data Coming Soon"
                      description="We're working on bringing you comprehensive vegetable farming insights"
                      icon={GiFruitBowl}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <HorticultureDashboard />
                  </TabPanel>
                  <TabPanel value={value} index={3}>
                    <EmptyState 
                      title="Aromatic Plants Section"
                      description="Aromatic plants data will be available soon with detailed analytics"
                      icon={TbPlant2}
                    />
                  </TabPanel>
                </div>
              </Box>
            </CardBody>
          </Card> */}
        </Page>
      </div>

      <Footer />
    </>
  );
};

export default Home;